import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { getApiErrorMessage, listEntitySources } from '../../api/client';
import type { EntitySourceSummary } from '../../api/types';
import Badge from '../../components/Badge';
import { useAuth } from '../../contexts/AuthContext';
import { canEditPlatformConfig, canWritePlatformConfig } from '../../utils/permissions';
import { PLATFORM_CONFIG } from '../platform-config/paths';

export default function EntitySourcesPage() {
  const { user } = useAuth();
  const [sources, setSources] = useState<EntitySourceSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const canCreate = user && canWritePlatformConfig(user);
  const canModify = user && canEditPlatformConfig(user);

  useEffect(() => {
    listEntitySources()
      .then(setSources)
      .catch((err) => setError(getApiErrorMessage(err)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      {canCreate && (
        <div className="page-header" style={{ marginTop: 0 }}>
          <div />
          <Link to={PLATFORM_CONFIG.sourcesNew} className="btn btn-primary">
            Add source
          </Link>
        </div>
      )}
      {error && <div className="alert alert-error">{error}</div>}
      <div className="card">
        {loading ? (
          <div className="loading">Loading sources…</div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Prefix rules</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {sources.map((s) => (
                <tr key={s.id}>
                  <td>
                    {canModify ? (
                      <Link to={PLATFORM_CONFIG.source(s.id)}>{s.code}</Link>
                    ) : (
                      s.code
                    )}
                  </td>
                  <td>{s.name}</td>
                  <td>{s._count?.enrollmentPrefixes ?? 0}</td>
                  <td>
                    <Badge
                      label={s.isActive ? 'ACTIVE' : 'INACTIVE'}
                      className={s.isActive ? 'badge-success' : 'badge-neutral'}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
